module.exports = "/_next/static/images/167adf8e0eeaf108b50987ce67fd96d9-att-icon.svg";